export enum ResourceAllocationEditType {
  EVENT = "EVENT",
  ALL = "ALL",
  FUTURE = "FUTURE"
}
